export default "__VITE_ASSET__BFP5bJ3E__"